import * as React from "react";

import { useMyBagOnThisPage, useMyBagPresentationModel } from "../providers";

import { PortalToPaymentPageSideSection } from "../portals";

import { MyBagSummary } from "../my-bag-summary";
import { ThisOrderWillBeShippedTo } from "../this-order-will-be-shipped-to";
import { GiftcardsAndPromotions } from "../giftcards-and-promotions";

import { FixMagentoPaymentSection } from "./fix-magento-payment-section";
import { useCallback } from "react";
import { useGtm } from "../../Common/analytics/gtm";

export const PagePayment: React.FunctionComponent = () => {
  const { presentationMyBagItems } = useMyBagPresentationModel();
  const { pushToTheDataLayer } = useGtm();

  const paymentGTM = useCallback(() => {
    if (presentationMyBagItems?.[0]?.sku) {
      const event = {
        event: "add_payment_info",
        ecommerce: {
          currency: "AUD",
          value: parseFloat(
            document.querySelector(
              "section.my-bag-summary > div.by-the-numbers > div.totalValueBreakdown > div.total-inc-gst > p.the-price.add-price > span.value"
            )?.innerText
          ),
          items: presentationMyBagItems.map((item) => ({
            item_id: item.sku,
            item_name: item.title,
            price: item.subtotal,
            quantity: item.howManyOfThisProduct,
          })),
        },
      };

      pushToTheDataLayer(event);
    }
  }, []);

  React.useEffect(() => {
    const timeoutID = window.setTimeout(() => {
      const payButtons = [
        ...document.getElementsByClassName("action primary checkout"),
      ];
      if (payButtons.length > 0) {
        payButtons.forEach((elem) =>
          elem.addEventListener("click", paymentGTM)
        );
      }
    }, 4000);

    return () => {
      const payButtons = [
        ...document.getElementsByClassName("action primary checkout"),
      ];
      if (payButtons.length > 0) {
        payButtons.forEach((elem) =>
          elem.removeEventListener("click", paymentGTM)
        );
      }
      window.clearTimeout(timeoutID);
    };
  }, [presentationMyBagItems.length]);

  useMyBagOnThisPage();

  return (
    <React.Fragment>
      <ThisOrderWillBeShippedTo />
      <GiftcardsAndPromotions />
      <PortalToPaymentPageSideSection>
        <MyBagSummary hideActions hideGiftcardNotice />
      </PortalToPaymentPageSideSection>
      <FixMagentoPaymentSection />
    </React.Fragment>
  );
};
